import { combineReducers } from "redux";
import { snacksReducer } from "./snacks/snacksReducers";
import { foodReducer } from "./food/foodReducer";
import { drinksReducer } from "./drinks/drinksReducer";


const rootReducer = combineReducers({
    snacks : snacksReducer,
    food : foodReducer,
    drinks : drinksReducer
})

export default rootReducer